export const ROUTES = {
  CONSUMPTION: '/consumption',
  PRICE_AND_COST: '/price-and-cost',
  USAGE_SITES: '/usage-sites',
  INVOICES: '/invoices',
  FORECAST: '/forecast',
  NEWS: '/news',
  USER_PROFILE: '/user-profile',
  USERS: '/users',
  NOT_FOUND: '/not-found',
  LOGIN: '/login',
  LOGOUT: '/logout',
  HOME: '/',
  USER_INVITATION: '/user-invitation',
  REGISTER_USER: '/registeruser',
} as const;

export const PUBLIC_ROUTES = [ROUTES.LOGIN, ROUTES.USER_INVITATION, ROUTES.REGISTER_USER] as const;
export const AUTH_ROUTES = [ROUTES.LOGIN] as const;

type ExtractRoutes<T> = T extends string
  ? T
  : T extends Record<string, unknown>
    ? { [K in keyof T]: ExtractRoutes<T[K]> }[keyof T]
    : never;

export type Route = ExtractRoutes<typeof ROUTES>;
